import { NumberOrNullOrUndefined, StringOrNullOrUndefined } from 'src/app/shared/utils';

export class RbtNotesByPlanMaladaptive {
  id: number;
  name: string;
  // Backend returns this key with this exact spelling.
  ocurrences: number;
  category: string;

  constructor(data: Partial<RbtNotesByPlanMaladaptive> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.name = StringOrNullOrUndefined(data.name) ?? '';
    this.ocurrences = NumberOrNullOrUndefined(data.ocurrences) ?? 0;
    this.category = StringOrNullOrUndefined(data.category) ?? '';
  }
}

export class RbtNotesByPlanReplacement {
  id: number;
  name: string;
  total_trials: number;
  correct_responses: number;
  first_trial: boolean;
  category: string;
  total_steps?: number;
  first_trial_steps?: { step_id: number; accomplished: boolean }[];

  constructor(data: Partial<RbtNotesByPlanReplacement> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.name = StringOrNullOrUndefined(data.name) ?? '';
    this.total_trials = NumberOrNullOrUndefined(data.total_trials) ?? 0;
    this.correct_responses = NumberOrNullOrUndefined(data.correct_responses) ?? 0;
    this.first_trial = Boolean(data.first_trial);
    this.category = StringOrNullOrUndefined(data.category) ?? '';
    this.total_steps = NumberOrNullOrUndefined(data.total_steps);
    this.first_trial_steps = Array.isArray(data.first_trial_steps)
      ? data.first_trial_steps.map((step) => ({
          step_id: NumberOrNullOrUndefined(step.step_id) ?? 0,
          accomplished: Boolean(step.accomplished),
        }))
      : [];
  }
}

export class RbtNotesByPlanNote {
  id: number;
  maladaptives: RbtNotesByPlanMaladaptive[];
  replacements: RbtNotesByPlanReplacement[];

  constructor(data: Partial<RbtNotesByPlanNote> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.maladaptives = (data.maladaptives ?? []).map(
      (item) => new RbtNotesByPlanMaladaptive(item)
    );
    this.replacements = (data.replacements ?? []).map(
      (item) => new RbtNotesByPlanReplacement(item)
    );
  }
}

export class RbtNotesByPlanMaladaptivePlan {
  plan_id: number;
  plan_name: string;
  total_occurrences: number;

  constructor(data: Partial<RbtNotesByPlanMaladaptivePlan> = {}) {
    this.plan_id = NumberOrNullOrUndefined(data.plan_id) ?? 0;
    this.plan_name = StringOrNullOrUndefined(data.plan_name) ?? '';
    this.total_occurrences = NumberOrNullOrUndefined(data.total_occurrences) ?? 0;
  }
}

export class RbtNotesByPlanReplacementPlan {
  plan_id: number;
  plan_name: string;
  total_trials: number;
  correct_responses: number;
  accuracy_percentage: number;

  constructor(data: Partial<RbtNotesByPlanReplacementPlan> = {}) {
    this.plan_id = NumberOrNullOrUndefined(data.plan_id) ?? 0;
    this.plan_name = StringOrNullOrUndefined(data.plan_name) ?? '';
    this.total_trials = NumberOrNullOrUndefined(data.total_trials) ?? 0;
    this.correct_responses = NumberOrNullOrUndefined(data.correct_responses) ?? 0;
    this.accuracy_percentage = NumberOrNullOrUndefined(data.accuracy_percentage) ?? 0;
  }
}

export class RbtNotesByPlanDaily {
  date: string;
  notes: RbtNotesByPlanNote[];

  constructor(data: Partial<RbtNotesByPlanDaily> = {}) {
    this.date = StringOrNullOrUndefined(data.date) ?? '';
    this.notes = (data.notes ?? []).map((note) => new RbtNotesByPlanNote(note));
  }
}

export class RbtNotesByPlan {
  full_name: string;
  notes_count: number;
  daily: RbtNotesByPlanDaily[];

  constructor(data: Partial<RbtNotesByPlan> = {}) {
    this.full_name = StringOrNullOrUndefined(data.full_name) ?? '';
    this.notes_count = NumberOrNullOrUndefined(data.notes_count) ?? 0;
    this.daily = (data.daily ?? []).map((d) => new RbtNotesByPlanDaily(d));
  }
}
